import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
import { Grid, Row, Col } from 'react-bootstrap';
import supportingImageOne from '../../img/home/interaction-rates.png';
import supportingImageTwo from '../../img/home/audience-map.png';
import './ConsumerIntelligence.css';

class ConsumerIntelligence extends Component {
  render() {
    return (
      <div className="consumer-intelligence">
        <Grid>
          <Row className="header-row">
            <h1 className="heading"> Consumer Intelligence</h1>
          </Row>
          <Row>
            <Col md={12} xs={12} className="blurb-col">
              <h3>
                Get access to valuable consumer {'&'} product data
                available through the platform analytics engine: location data;
                consumer profiles; frequency of engagement, individual bottle data.
              </h3>
            </Col>
          </Row>
          <Row className="visualisation-row">
            <Fade delay={300} duration={1500}>
              <Col xs={12} md={6} s={12} className="visualisation-col-one">
                <div className="image-container">
                  <img src={supportingImageOne} className="img-responsive featured-img" alt="Storybook Consumer Interaction Rates" />
                  <h4>Discover consumer interaction rates</h4>
                </div>
              </Col>
            </Fade>
            <Fade delay={800} duration={1500}>
              <Col xs={12} md={6} s={12} className="visualisation-col-two">
                <div className="image-container">
                  <img src={supportingImageTwo} className="img-responsive featured-img" alt="Storybook Analytics" />
                  <h4>See where your products are popular and identify new markets</h4>
                </div>
              </Col>
            </Fade>
          </Row>
          <Row className="feature-row">
            <Fade delay={100}>
              <Col md={4} xs={12} className="feature">
                <h3>Track</h3>
                <p className="feature-description">
                  Use consumer scannable technology (QR/NFC/RFID) to follow your assets
                  through the chain
                </p>
              </Col>
            </Fade>
            <Fade delay={300}>
              <Col md={4} xs={12} className="feature">
                <h3>Explore </h3>
                <p className="feature-description">
                  Access to Big Data analytics unlocks new intelligence allowing better targeting
                  for marketing spend
                </p>
              </Col>
            </Fade>
            <Fade delay={500}>
              <Col md={4} xs={12} className="feature">
                <h3>Protect</h3>
                <p className="feature-description">
                  By marrying unique IDs and arc-net’s blockchain technology we can help reduce
                  counterfeiting and parallel trading
                </p>
              </Col>
            </Fade>
          </Row>

        </Grid>
      </div >
    );
  }
}

export default ConsumerIntelligence;




// WEBPACK FOOTER //
// ./src/components/common/ConsumerIntelligence.js